import { useState, useCallback } from "react";

import { produce } from "immer";

interface IUseCountriesSelectionReturn {
    selectedCountries: number[];
    setSelectedCountries: (countries: number[]) => void;
    toggleCountry: (countryId: number) => void;
    resetCountries: () => void;
}

export const useCountriesSelection = (): IUseCountriesSelectionReturn => {
    const [selectedCountries, setSelectedCountriesState] = useState<number[]>([]);

    const setSelectedCountries = useCallback((countries: number[]) => {
        setSelectedCountriesState(countries);
    }, []);

    const toggleCountry = useCallback((countryId: number) => {
        setSelectedCountriesState(
            produce((draft) => {
                const index = draft.indexOf(countryId);
                if (index !== -1) {
                    draft.splice(index, 1);
                } else {
                    draft.push(countryId);
                }
            }),
        );
    }, []);

    const resetCountries = useCallback(() => {
        setSelectedCountriesState([]);
    }, []);

    return {
        selectedCountries,
        setSelectedCountries,
        toggleCountry,
        resetCountries,
    };
};
